import { AfterViewInit, Component, Inject, Input, HostListener
       } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Placeholder } from 'collage-designer/stage/placeholder/placeholder';
import { ToolboxService } from './toolbox.service';

@Component({
    template: '',
    standalone: false
})
export class ToolboxComponent
{
  protected name: string;

  constructor(
      @Inject(ToolboxService) protected toolboxService: ToolboxService)
  {
    this.toolboxService.closeRequested
        .pipe(takeUntilDestroyed())
        .subscribe(toolboxName => {
          if (toolboxName === this.name) {
            this.respondToCloseRequest();
          }
        });
  }

  protected respondToCloseRequest(): void
  {
    this.btnCloseClick();
  }

  public btnCloseClick(): void
  {
    this.toolboxService.cleanUp(this.name);
  }
}
